import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import WOW from "wowjs";
import axios from 'axios';

export default function Help() {

  const [helpData, setHelpData] = useState(null);

  useEffect(() => {
    axios.get('https://solanthegroup.com/admin/api/helps')
      .then(response => {
        if (response.data.length > 0) {
          setHelpData(response.data[0]);
        }
      })
      .catch(error => console.error("Error fetching about data:", error));

    const wow = new WOW.WOW({ live: false });
    wow.init();


  }, []);

  if (!helpData) return <div></div>;


  return (
    <div>
      <div
        className="signle-side-bar call-to-action bg-image"
        style={{ backgroundImage: `url(${helpData.signle_side_bar_photo})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>

        <div className="easy-call-to-action">
          <div className="icon-center-call">
            <i className="fa-light fa-phone" />
          </div>
          <h3 className="title animated fadeIn">{helpData.signle_side_bar_title}</h3>
          <p className="disc">
            {helpData.signle_side_bar_description}
          </p>
          <a href="Tel:1234567890">{helpData.signle_side_bar_phone}</a>
        </div>
      </div>
      <style>{`
          .bg-image{
              background-image:url(https://solanthegroup.com/admin/${helpData.signle_side_bar_photo})!important
          }            
      `}</style>
    </div>
  )
}
